import { default as AbstractModal } from './AbstractModal'

export default class ModalAreas extends AbstractModal {

    constructor(m) {
        super(m)

        // Events
        this.events = {
            click: {
                'open': 'open',
                'close': 'close',
            },
        }
    }

    onClose() {
        this.call('unlockReduced', null, 'Header')
    }
}
